import React from 'react';
import { Bot } from 'lucide-react';
import {
  PromoCard,
  PromoCardBody,
  PromoCardDesc,
  PromoCardHeader,
  PromoCardTitle,
} from '@/components/promo/PromoCard';

const EXERCISES = [
  { icon: '🎸', title: 'C major scale · tempo 80', meta: 'Reference upload · 45 sec' },
  { icon: '🎵', title: 'Fingerpicking pattern #2', meta: 'Reference upload · 32 sec' },
  { icon: '🎼', title: 'Chord change drill · Am–G–F', meta: 'Reference upload · 28 sec' },
];

const METRICS = [
  { label: 'Timing alignment', pct: 88 },
  { label: 'Pitch accuracy', pct: 85 },
  { label: 'Dynamics', pct: 82 },
  { label: 'Note clarity', pct: 90 },
];

const TeacherAiPracticePage: React.FC = () => (
  <PromoCard>
    <PromoCardHeader>
      <PromoCardTitle icon={<Bot size={20} strokeWidth={2} />}>AI Practice</PromoCardTitle>
      <PromoCardDesc>
        Teachers upload exercises · students record offline · AI benchmarks against your reference
        take.
      </PromoCardDesc>
    </PromoCardHeader>
    <PromoCardBody>
      <div className="ai-grid">
        <div className="ai-pane">
          <div className="ai-pane-h">
            Your exercises <span className="ai-credits">Student credits</span>
          </div>
          <div className="ai-pane-b">
            {EXERCISES.map((ex) => (
              <div key={ex.title} className="ai-exercise">
                <div className="ai-ex-icon">{ex.icon}</div>
                <div>
                  <div className="ai-ex-title">{ex.title}</div>
                  <div className="ai-ex-meta">{ex.meta}</div>
                </div>
              </div>
            ))}
            <p className="ai-split">
              Practice credits · 50/50 earnings split with you after fees · passive income between
              lessons
            </p>
          </div>
        </div>
        <div className="ai-pane">
          <div className="ai-pane-h">
            Student practice <span className="ai-credits">12 credits left</span>
          </div>
          <div className="ai-pane-b">
            <button type="button" className="studio-send" style={{ marginBottom: 12 }}>
              ● Record take
            </button>
            <div className="ai-bench">
              <div className="ai-bench-head">
                <div className="ai-match-score">
                  <b>87%</b>
                  <span>overall match</span>
                </div>
                <span className="ai-grade">Strong</span>
              </div>
              <p className="ai-bench-summary">
                Timing is tight on the turnaround; pitch holds through the scale. Dynamics match
                your reference take on the final phrase.
              </p>
              <div className="ai-metrics">
                {METRICS.map((m) => (
                  <div key={m.label} className="ai-metric" style={{ ['--pct' as string]: `${m.pct}%` }}>
                    <div className="ai-metric-top">
                      <span>{m.label}</span>
                      <b>{m.pct}%</b>
                    </div>
                    <div className="ai-metric-bar">
                      <i />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </PromoCardBody>
  </PromoCard>
);

export default TeacherAiPracticePage;
